// La redacción arranca SOLA apenas se abre su puerta (Rodgers, 26-10-2026): la
// pone en marcha el servidor al responder la última duda, al cerrar la última
// corrección o al terminar bien el análisis. La pantalla no la inicia; solo
// tiene que enterarse.

import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { corridaDeLaRedaccionKey, seccionesKey } from "@/hooks/useRedaccion";

/**
 * Relee la corrida de redacción y las secciones después de un acto que pudo
 * abrir la puerta. La corrida no se sondea mientras no está en curso, así que
 * sin esto la redacción que arrancó sola no se vería hasta recargar.
 */
export function useReleerLaRedaccion(informeId: number) {
  const queryClient = useQueryClient();

  return useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: corridaDeLaRedaccionKey(informeId) });
    void queryClient.invalidateQueries({ queryKey: seccionesKey(informeId) });
  }, [informeId, queryClient]);
}
